export default __webpack_public_path__ + "static/media/passive.debf8fac.svg";